import { createContext, useContext, useState, useMemo, useEffect } from "react";
import axios from "axios";
import { translations } from "@/i18n/translations";
import { extra } from "@/i18n/extra";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const setPath = (obj, path, value) => {
  const keys = path.split(".");
  let cur = obj;
  for (let i = 0; i < keys.length - 1; i++) {
    const k = keys[i];
    if (cur[k] === undefined) cur[k] = isNaN(Number(keys[i + 1])) ? {} : [];
    cur = cur[k];
  }
  const last = keys[keys.length - 1];
  cur[isNaN(Number(last)) ? last : Number(last)] = value;
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("fr");
  const [overrides, setOverrides] = useState({});

  useEffect(() => {
    axios
      .get(`${API}/content`)
      .then((res) => setOverrides(res.data || {}))
      .catch(() => {});
  }, []);

  const value = useMemo(() => {
    const merged = structuredClone({ ...translations[lang], ...extra[lang] });
    Object.entries(overrides).forEach(([key, val]) => {
      const v = val && val[lang];
      if (v) setPath(merged, key, v);
    });
    return { lang, setLang, t: merged };
  }, [lang, overrides]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => useContext(LanguageContext);
